var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11104_7724",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11104_7724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.09627 17.0834C5.92849 17.0834 4.93995 16.6787 4.13065 15.8694C3.32134 15.0601 2.91669 14.0706 2.91669 12.9011C2.91669 12.4127 3.0003 11.9372 3.16752 11.4746C3.33474 11.0118 3.57433 10.5925 3.88627 10.2165L6.82856 6.67794L5.50002 4.00481C5.37183 3.75384 5.3796 3.50974 5.52335 3.27252C5.66697 3.0353 5.88252 2.91669 6.17002 2.91669H13.83C14.1175 2.91669 14.3331 3.0353 14.4767 3.27252C14.6204 3.50974 14.6282 3.75384 14.5 4.00481L13.1715 6.67794L16.1138 10.2165C16.4257 10.5925 16.6653 11.0118 16.8325 11.4746C16.9997 11.9372 17.0834 12.4127 17.0834 12.9011C17.0834 14.0706 16.677 15.0601 15.8644 15.8694C15.0516 16.6787 14.0647 17.0834 12.9038 17.0834H7.09627ZM9.99856 13.1169C9.58398 13.1169 9.22954 12.9693 8.93523 12.674C8.64078 12.3787 8.49356 12.0238 8.49356 11.6092C8.49356 11.1945 8.6412 10.84 8.93648 10.5456C9.23176 10.2513 9.58676 10.1042 10.0015 10.1042C10.4161 10.1042 10.7705 10.2518 11.0648 10.5471C11.3593 10.8424 11.5065 11.1974 11.5065 11.6121C11.5065 12.0267 11.3588 12.3811 11.0636 12.6754C10.7683 12.9697 10.4133 13.1169 9.99856 13.1169ZM7.97273 6.14585H12.0352L13.0209 4.16669H6.97919L7.97273 6.14585ZM7.09627 15.8334H12.9038C13.7224 15.8334 14.4153 15.5484 14.9825 14.9784C15.5497 14.4084 15.8334 13.7163 15.8334 12.9021C15.8334 12.5592 15.7743 12.2262 15.6563 11.9031C15.5382 11.58 15.3697 11.288 15.1506 11.0273L12.1281 7.39585H7.89273L4.85731 11.0144C4.63828 11.2751 4.46842 11.5695 4.34773 11.8977C4.22703 12.2258 4.16669 12.5611 4.16669 12.9036C4.16669 13.7168 4.45169 14.4084 5.02169 14.9784C5.59169 15.5484 6.28322 15.8334 7.09627 15.8334Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/money_bag.452d7e8963b7008eba7e57c627c3fa42.svg";
export { ForwardRef as ReactComponent };